import React from 'react';
import LegalPage from './LegalPage';

const TermsOfService = () => (
  <LegalPage title="Terms of Service" updated="25 April 2026">
    <p>
      These Terms govern use of the EduManage platform operated by{' '}
      <strong>RT Connect Technology Pvt Ltd</strong>, a company incorporated in
      India ("RT Connect", "we", "us"). By signing up for or using EduManage —
      through the web application at edu.rtconnect.in (and tenant subdomains
      such as <code>&lt;school&gt;.edu.rtconnect.in</code>) or the mobile
      apps — you agree to these Terms.
    </p>

    <h2>1. The service</h2>
    <p>
      EduManage is a multi-tenant school management platform. Each school gets
      an isolated workspace and branded subdomain. The service includes
      admissions, attendance, marks, homework, timetable, circulars, health
      records, achievements, and associated reporting.
    </p>

    <h2>2. Accounts and roles</h2>
    <ul>
      <li>A <strong>school admin</strong> is the primary account holder for the school. They create other users (teachers, parents, students).</li>
      <li><strong>Teachers, parents and students</strong> access the service under their school's subscription.</li>
      <li><strong>Platform owner</strong> accounts (RT Connect staff) can view platform-wide metrics but do not access per-school records without the school's explicit consent.</li>
      <li>You must keep your login credentials confidential. You are responsible for all activity under your account.</li>
    </ul>

    <h2>3. Subscription plans and billing</h2>
    <p>
      Each school is billed on one of the published plans (Free, Basic,
      Premium, or Enterprise). Current pricing is visible on the owner
      dashboard when you sign up.
    </p>
    <ul>
      <li>Subscriptions are billed monthly or annually in advance, in INR, by invoice or bank transfer</li>
      <li>Indian GST is added where applicable</li>
      <li>Paid plans auto-renew unless cancelled at least 7 days before the renewal date</li>
      <li>Fees are non-refundable for the current billing period once charged, except as required by applicable law</li>
      <li>Enterprise plans are priced per individual agreement</li>
    </ul>

    <h2>4. Acceptable use</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Upload content that infringes intellectual-property rights</li>
      <li>Upload child-exploitation material, harassment, or any content that would harm a minor</li>
      <li>Attempt to breach security, access another school's records, or disrupt the service</li>
      <li>Reverse-engineer, copy, or redistribute the platform</li>
      <li>Use the platform to send unsolicited bulk messages</li>
    </ul>
    <p>
      Violation may result in suspension or termination of the affected account
      or the school's entire subscription.
    </p>

    <h2>5. Your data</h2>
    <p>
      The school owns the records it creates on the platform. We process them
      on the school's behalf as described in our{' '}
      <a href="/privacy">Privacy Policy</a>. The school can export its data at
      any time via the built-in CSV / PDF exports on the Attendance and Marks
      pages.
    </p>

    <h2>6. Availability</h2>
    <p>
      We aim for 99.5% availability. Planned maintenance is announced in the
      app at least 24 hours in advance. Service interruptions outside our
      control (ISP, upstream provider, natural disaster) are not our liability.
    </p>

    <h2>7. Termination</h2>
    <p>A school can cancel at any time from its admin dashboard or by writing
      to us. We can terminate a subscription for non-payment after 30 days of
      delinquency, or immediately for serious policy violations (see Section 4).
    </p>
    <p>
      On termination, see the retention and deletion provisions in our{' '}
      <a href="/privacy">Privacy Policy</a> and{' '}
      <a href="/data-deletion">Data Deletion</a> pages.
    </p>

    <h2>8. Intellectual property</h2>
    <p>
      EduManage, the RT Edu Services brand, the logo, and all platform source
      code are owned by RT Connect. You receive a limited, non-exclusive,
      non-transferable licence to use the service for the duration of your
      subscription.
    </p>

    <h2>9. Limitation of liability</h2>
    <p>
      To the maximum extent permitted by Indian law, RT Connect's total
      liability for any claim arising from the service is limited to the
      amount the school paid in the 12 months preceding the claim. We are not
      liable for indirect, consequential, or punitive damages.
    </p>

    <h2>10. Changes to these Terms</h2>
    <p>
      We may update these Terms from time to time. Material changes will be
      announced in-app and via email to school admins at least 14 days in
      advance. Continued use after the effective date constitutes acceptance.
    </p>

    <h2>11. Governing law and jurisdiction</h2>
    <p>
      These Terms are governed by the laws of India. Disputes are subject to
      the exclusive jurisdiction of the competent courts at Hyderabad, Telangana.
    </p>

    <h2>12. Contact</h2>
    <p>
      RT Connect Technology Pvt Ltd<br />
      Email: <a href="mailto:pramod@rtconnect.in">pramod@rtconnect.in</a><br />
      Web: <a href="https://rtconnect.in">rtconnect.in</a>
    </p>
  </LegalPage>
);

export default TermsOfService;
